module.exports = __webpack_public_path__ + "img/function_header_image.bbbe06cf.png";